//Authenticate

// Auth — route BE TXNG thật (KHÔNG phải /api/identity/* của qlrv)
export const apiLogin = `/connect/token`
export const apiGoogleLogin = `/api/identity/google-login`
export const apiLogout = `/api/identity/logout`
export const apiRefreshToken = `/api/Authservice/RefreshToken`
export const apiChangePassword = `/api/identity/changePassword`
export const apiGetInfo = `/api/identity/getInfo`
export const apiGetTabs = `/api/Role/GetListTab`
export const apiUpdateAvatar = `/api/identity/updateAvatar`
export const apiUpdateInfo = `/api/identity/updateInfo`
export const apiChangeHistory = `/api/identity/changeHistory`
export const apiLoginGG = `/api/identity/google-login`
export const apiCompleteStaffDetails = `/api/identity/completeStaffDetails`
export const apiCompleteGuestDetails = `/api/identity/completeGuestDetails`
export const apiRegister = `/api/identity/register`
